/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const o=[];function t(t){o.push(t),1===o.length&&queueMicrotask(()=>{const t=o.slice();o.length=0;for(const o of t)o()})}export{t as nextTick};
